<template>
  <collapsible-section title="PIM_PRODUCT-ACCORDION_TITLE-PRICING" :defaultOpen="defaultOpen">

    <!-- price -->
    <template v-if="pharmacy !== null">
      <form-input
        inputType="text"
        :label="
          pharmacy.erp != null
            ? 'PIM_PRODUCT_PRICE_' + pharmacy.erp.toUpperCase()
            : 'PIM-PRODUCT-PRICE' + labelSuffix
        "
        v-model="product.erp.price"
        :isReadOnly="product.erp.readonly"
        :isPointToComma="true"
      ></form-input>
    </template>
    <template v-else>
      <form-input
        inputType="text"
        label="PIM-PRODUCT-PRICE"
        v-model="product.price"
        :isReadOnly="true"
        :isPointToComma="true"
      ></form-input>
    </template>

    <!-- vatPercent -->
    <form-input
      inputType="text"
      :label="'PIM-PRODUCT-VAT_PERCENT' + labelSuffix"
      v-model="product.vatPercent"
      :isReadOnly="isReadonly" 
      :isPointToComma="true"
    ></form-input>

    <!-- Score -->
    <form-input
      inputType="text"
      :label="'PIM-PRODUCT-SCORE' + labelSuffix"
      v-model="product.score"
      :isReadOnly="isReadonly"
      :isPointToComma="true"
    ></form-input>

    <!-- unitPrice -->
    <form-input
      inputType="text"
      :label="'PIM-PRODUCT-UNIT_PRICE' + labelSuffix"
      v-model="product.unitPrice"
    ></form-input>

  </collapsible-section>
</template>

<script>
import CollapsibleSection from "../../utils/CollapsibleSection.vue";

export default {
  name: "ProductSectionPricing",

  components: {
    CollapsibleSection,
  },

  props: {
    product: { type: Object, required: true },
    pharmacy: { type: Object, default: null },
    isReadonly: { type: Boolean, default: false },
    labelSuffix: { type: String, default: "" },
    defaultOpen: { type: Boolean, default: false },
  },
};
</script>
